export const backgroundColorLight = 'transparent';
export const backgroundColorDark = '#454545';
export const backgroundColorBackdrop = '#00000060';
export const colorTextDark = '#1C2833';
